import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { portalApi } from '../../../../../../../../../../api';
import { createToast } from '../../../../../../../../../../redux/modules/app';
import { showModal } from '../../../../../../../../../../redux/modules/modal';
import { useRequestCompanyFeature } from '../../../../../../../../../../services/company-service';
import colors from '../../../../../../../../../../styles/theme/foundation/colors';
import PINSAIAssistantLabel from '../../../../../../../../../PINSAIAssistantLabel';
import PINSAIOutlineGradientButton from '../../../../../../../../../PINSAIOutlineGradientButton';
import PINSAISparkIcon from '../../../../../../../../../PINSAISparkIcon';
import DemoModal from '../DemoModal';
import StartingTrialModal from '../StartingTrialModal';

const FeatureDisabled = ({ companyId, featureTypeId }) => {
  const dispatch = useDispatch();
  const { mutateAsync } = useRequestCompanyFeature({ companyId });

  return (
    <Box>
      <Text
        mb={6}
        mt={8}
        textStyle="bodySm600"
      >
        Introducing
      </Text>

      <PINSAIAssistantLabel mx="auto" w="200px" />

      <Box mt={2} px={8} py={4}>
        <Text
          fontWeight="700"
          textStyle="displayXs600"
        >
          Stop Reviewing.
        </Text>
        <Text
          fontWeight="700"
          mb={4}
          textStyle="displayXs600"
        >
          Start Approving.
        </Text>

        <Text
          mb={4}
          textStyle="bodyXl"
        >
          Insurance compliance made smarter with AI.
        </Text>

        <Box maxW="295px">
          <PINSAISparkIcon mb={2} mx="auto" w="25px" />
          <Text
            fontSize="14px"
            fontWeight="600"
            mb={4}
          >
            Automatically review COIs and endorsements
          </Text>
        </Box>

        <Box maxW="295px">
          <PINSAISparkIcon mb={2} mx="auto" w="25px" />
          <Text
            fontSize="14px"
            fontWeight="600"
            mb={4}
          >
            Deliver real-time compliance review
          </Text>
        </Box>

        <Box maxW="295px">
          <PINSAISparkIcon mb={2} mx="auto" w="25px" />
          <Text
            fontSize="14px"
            fontWeight="600"
            mb={6}
          >
            Streamline communication with your insureds
          </Text>
        </Box>

        <Box mb={2} mt={4}>
          <Button
            variant="gradientAi"
            w="100%"
            onClick={async () => {
              await mutateAsync({ featureTypeId });

              dispatch(showModal(StartingTrialModal, {
                size: 'sm',
                borderProps: {
                  border: '1px solid transparent',
                  borderRadius: 'md',
                  backgroundImage:
                    `linear-gradient(white, white), ${colors.gradient.aiPrimary}`,
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box'
                }
              }));
            }}
          >
            Request Free Trial
          </Button>
          <PINSAIOutlineGradientButton
            text="See How It Works"
            variant="aiGradientOutlineBlack"
            w="100%"
            onClick={() => {
              dispatch(showModal(DemoModal, {
                title: 'PINS AI Assistant Demo',
                size: '6xl'
              }));
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

FeatureDisabled.propTypes = {
  companyId: PropTypes.number.isRequired,
  featureTypeId: PropTypes.number.isRequired
};

export default FeatureDisabled;
